import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Package, Home } from 'lucide-react';

const OrderSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState(null);
  
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // You could fetch order details here if needed
    // For now, just show success message
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-6">
      <Card className="max-w-2xl w-full">
        <CardContent className="p-12 text-center">
          {/* Success Icon */}
          <div className="mb-6 flex justify-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>

          {/* Success Message */}
          <h1 className="text-3xl font-bold text-slate-900 mb-4">
            Order Placed Successfully! 🎉
          </h1>
          <p className="text-lg text-slate-600 mb-8">
            Thank you for your order! Your stickers will be processed and shipped within 3-5 business days.
          </p>

          {/* Order Info */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8 text-left">
            <div className="flex items-start gap-3 mb-4">
              <Package className="w-5 h-5 text-blue-600 mt-0.5" />
              <div className="text-sm text-blue-900">
                <p className="font-semibold mb-2">What happens next?</p>
                <ul className="space-y-1.5 list-disc list-inside">
                  <li>You'll receive an order confirmation email shortly</li>
                  <li>Your order will be processed within 2-3 business days</li>
                  <li>Once shipped, you'll receive a tracking number</li>
                  <li>Delivery typically takes 3-5 business days</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outline"
              size="lg"
            >
              <Home className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
            <Button
              onClick={() => navigate('/orders/my-orders')}
              size="lg"
            >
              View My Orders
            </Button>
          </div>

          {/* Additional Info */}
          <p className="text-sm text-slate-500 mt-8">
            Questions about your order? Contact us at support@edutracker.app
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default OrderSuccessPage;
